goog.require('el8.app.settings.settingsNav');
goog.require('el8.app.setup');
goog.require('el8.data.practiceUsers');
goog.require('el8.service.tz');
goog.require('el8.util.base');

var el8 = el8 || {};
if (!el8.main) {
  el8.main = {};
}
if (!el8.main.app) {
  el8.main.app = {};
}
el8.main.app.settings = {};

el8.main.app.settings.init = function(spec) {
  spec['layout'] = { innerContainerSelector: '#settings-container' };
  el8.app.setup(spec);

  el8React.configureStore(spec.data);
  el8React.renderFindChartHeaderButton('react-chartnav');

  el8React.renderDialogs('settings-react-dialogs-container');

  el8.data.practiceUsers.load();

  var defaultTab = el8.util.getUrlParam('tab');

  if (!defaultTab) {
    // Supposes that settings page URL is `/settings/tab-name/maybe-sub-tab-name`
    defaultTab = window.location.pathname.split('/')
    .filter(function(pathElement) {
      return !!pathElement
    })[1]
  }
  el8.app.settings.settingsNav.init(defaultTab);
};
